import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, can } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import OrderForm from "@/pages/OrderForm";
import OrderDetail from "@/pages/OrderDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Vehicles from "@/pages/Vehicles";
import Services from "@/pages/Services";
import Inventory from "@/pages/Inventory";
import Appointments from "@/pages/Appointments";
import Finance from "@/pages/Finance";
import UsersPage from "@/pages/Users";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";

function Protected({ module, children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Завантаження...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (module && !can(user, module))
    return <Layout><div className="text-center py-20 text-muted-foreground">Немає доступу до цього розділу</div></Layout>;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <SettingsProvider>
    <AuthProvider>
      <Toaster position="top-right" theme="light" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Protected module="dashboard"><Dashboard /></Protected>} />
          <Route path="/orders" element={<Protected module="orders"><Orders /></Protected>} />
          <Route path="/orders/new" element={<Protected module="orders"><OrderForm /></Protected>} />
          <Route path="/orders/:id/edit" element={<Protected module="orders"><OrderForm /></Protected>} />
          <Route path="/orders/:id" element={<Protected module="orders"><OrderDetail /></Protected>} />
          <Route path="/appointments" element={<Protected module="appointments"><Appointments /></Protected>} />
          <Route path="/clients" element={<Protected module="clients"><Clients /></Protected>} />
          <Route path="/clients/:id" element={<Protected module="clients"><ClientDetail /></Protected>} />
          <Route path="/vehicles" element={<Protected module="vehicles"><Vehicles /></Protected>} />
          <Route path="/services" element={<Protected module="services"><Services /></Protected>} />
          <Route path="/inventory" element={<Protected module="inventory"><Inventory /></Protected>} />
          <Route path="/finance" element={<Protected module="finance"><Finance /></Protected>} />
          <Route path="/users" element={<Protected module="users"><UsersPage /></Protected>} />
          <Route path="/settings" element={<Protected module="settings"><Settings /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </SettingsProvider>
  );
}

export default App;
